import React, { useEffect, useState } from "react";
import { contestDummyBanners, dummyBanners } from "../home.constant";
import { Network } from "../../../utils/network";
import { TabActions, useNavigation } from "@react-navigation/native";
import PlatformSpecificBanner from "./PlatformSpecificBanner";
import {
  atob,
  isMobile,
  trackMoengageEvent,
} from "../../../utils/commonMethods";
import { Linking, View } from "react-native";
import { deepLinkConst, deeplinkTabs } from "../../../common/dynamicLinkConst";
import { globalImport } from "../../../common/globalImports";
import {GlobalScreens} from "../../../utils/globalConstant";

const HomeBanners = ({onLearnMore, isLoadProbe, screen, globalConfigData}) => {
  const navigation = useNavigation();
  const [banners, setBanners] = useState(screen === "home" && GlobalScreens.Home.isShowDefaultBanner ? dummyBanners : []);

  useEffect(() => {
    if (screen === 'wallet' || screen === 'contest') {
      getBanners();
    } else if (
      screen === 'home' &&
      globalConfigData?.sortingOptions?.length > 0
    ) {
      getBanners();
    }
  }, [globalConfigData?.sortingOptions]);

  useEffect(() => {
    if (isLoadProbe) {
      getBanners();
    }
  }, [isLoadProbe]);

  const getBanners = async () => {
    const res = await Network.getBanners(screen);

    if (res?.data?.success !== false) {
      setBanners(res?.data?.banners || []);
    } else {
      setBanners([]);
    }
  };

  const onBannerClick = banner => {
    trackMoengageEvent('Clicked on Banner', {
      Page: screen,
      link: banner?.link,
    });
    if (banner?.action === 'htt') {
      if (screen === 'home') {
        if (isMobile()) {
          onLearnMore();
        } else {
          Linking.canOpenURL(globalConfigData?.howToTradeVideo).then(
            supported => {
              if (supported) {
                Linking.openURL(globalConfigData?.howToTradeVideo);
              } else {
                console.log(
                  "Don't know how to open URI: " +
                    globalConfigData?.howToTradeVideo,
                );
              }
            },
          );
        }
      } else if ((screen = 'contest')) {
        if (isMobile()) {
          onLearnMore();
        }
      }
    } else if (banner?.action === 'external') {
      if (banner?.link) {
        Linking.canOpenURL(banner?.link).then(supported => {
          if (supported) {
            Linking.openURL(banner?.link);
          } else {
            console.log("Don't know how to open URI: " + banner?.link);
          }
        });
      }
    } else if (banner?.action === 'inApp' && banner?.link) {
      if (deeplinkTabs.includes(banner?.link)) {
        const jumpToAction = TabActions.jumpTo(deepLinkConst[banner?.link]);
        navigation.navigate('Home');
        navigation.dispatch(jumpToAction);
      } else if (deepLinkConst[banner?.link]) {
        const pageObj = deepLinkConst[banner?.link];
        if (pageObj.child) {
          navigation.navigate(pageObj.parent, {screen: pageObj.child});
        } else {
          navigation.navigate(pageObj.parent);
        }
      } else if (banner?.link.includes('trending')) {
        const spliArr = banner?.link.split('=');
        const internalEvent = atob(spliArr[1]);
        navigation.navigate('HashTag', {hash_tag: internalEvent});
      } else if (banner?.link.includes('event')) {
        const spliArr = banner?.link.split('=');
        const internalEvent = {id: spliArr[1]};
        navigation.push('Event', {
          eventId: internalEvent?.id,
          isMulti: internalEvent?.parent_id === -1 ? true : false,
        });
      } else if (banner?.link.includes('club_id')) {
        const spliArr = banner?.link.split('=');
        navigation.navigate('ClubStack', {
          screen: 'ClubMarkets',
          params: {club_id: spliArr[1]},
        });
      }
    }
  };

  return (
    <>
      {banners?.length > 0 ? (
        <View
          style={{
            marginBottom: globalImport?.isWeb ? 15 : 0,
            marginTop: screen !== 'home' && !globalImport?.isWeb ? 20 : 0,
          }}>
          <PlatformSpecificBanner
            banners={banners}
            onBannerClick={onBannerClick}
            screen={screen}
          />
        </View>
      ) : (
        <></>
      )}
    </>
  );
};

export default HomeBanners;
